import React from "react";
import {
    IonContent,
    IonList,
    IonItem,
    IonLabel,
    IonText,
    IonButton,
    IonIcon,
    IonModal,
    IonHeader,
    IonToolbar,
    IonTitle, IonButtons,
} from "@ionic/react";
import {arrowBack, notificationsOutline} from "ionicons/icons";
import {FacebookLoader} from "./Loader/FacebookLoader";
import useStore from "../zustand/useStore";
import {actionToUpdateNotificationSeen} from "../apiHelpers/CommonAction";
import {useHistory} from "react-router";

const NotificationSheet = () => {
    const {notificationSheetOpen, setNotificationSheetOpen,notificationsDataState} = useStore();
    const {loading, notifications} = notificationsDataState;
    const history = useHistory();

    const onClose = ()=>{
        setNotificationSheetOpen(false);
    }

    const onMarkSeen = (id)=>{
        actionToUpdateNotificationSeen(id);
    }

    const redirectToModule = (notification) => {
        if (!notification) return;

        actionToUpdateNotificationSeen(notification.id);
        setNotificationSheetOpen(false);

        const name = (notification.object_name || "").toLowerCase();
        const id = notification.object_id;

        if (name.includes("event")) {
            if (id) {
                history.replace(`/dashboard/events/${id}`);
                return;
            }
            history.replace(`/dashboard/events`);
            return;
        }

        if (name.includes("job")) {
            if (id) {
                history.replace(`/dashboard/job-portal/${id}`);
                return;
            }
            history.replace(`/dashboard/job-portal`);
            return;
        }

        if (name.includes("assignments")) {
            if (id) {
                history.replace(`/dashboard/assignments/${id}`);
                return;
            }
            history.replace(`/dashboard/assignments`);
            return;
        }

        if (name.includes("newsletter")) {
            if (id) {
                history.replace(`/dashboard/newsletter/${id}`);
                return;
            }
            history.replace(`/dashboard/newsletter`);
            return;
        }
    };


    return (
        <IonModal
            isOpen={notificationSheetOpen}
            onDidDismiss={onClose}
            initialBreakpoint={1}
            breakpoints={[0, 1]}
            handleBehavior="cycle"
        >
            <IonHeader className="job_detail_sheet_header sheet_modal_header">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton className={"close_job_post_button"} onClick={onClose}>
                            <IonIcon icon={arrowBack}/>
                        </IonButton>
                    </IonButtons>
                    <IonTitle>Notifications</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent className="ion-padding bottom-2 no_padding_top">
                {loading ?
                    <>
                        <tr>
                            <td> <FacebookLoader type={"facebookStyle"} item={1}/></td>
                            <td> <FacebookLoader type={"facebookStyle"} item={1}/></td>
                            <td><FacebookLoader type={"facebookStyle"} item={1}/></td>
                            <td> <FacebookLoader type={"facebookStyle"} item={1}/></td>
                            <td><FacebookLoader type={"facebookStyle"} item={1}/></td>
                            <td><FacebookLoader type={"facebookStyle"} item={1}/></td>
                        </tr>
                        <tr>
                            <td> <FacebookLoader type={"facebookStyle"} item={1}/></td>
                            <td> <FacebookLoader type={"facebookStyle"} item={1}/></td>
                            <td><FacebookLoader type={"facebookStyle"} item={1}/></td>
                            <td> <FacebookLoader type={"facebookStyle"} item={1}/></td>
                            <td><FacebookLoader type={"facebookStyle"} item={1}/></td>
                            <td><FacebookLoader type={"facebookStyle"} item={1}/></td>
                        </tr>
                        <tr>
                            <td> <FacebookLoader type={"facebookStyle"} item={1}/></td>
                            <td> <FacebookLoader type={"facebookStyle"} item={1}/></td>
                            <td><FacebookLoader type={"facebookStyle"} item={1}/></td>
                            <td> <FacebookLoader type={"facebookStyle"} item={1}/></td>
                            <td><FacebookLoader type={"facebookStyle"} item={1}/></td>
                            <td><FacebookLoader type={"facebookStyle"} item={1}/></td>
                        </tr>
                    </>
                    :
                    notifications.length === 0 ? (
                        <div className="no-notifications">
                            <IonIcon icon={notificationsOutline} size="large" />
                            <IonText>No new notifications</IonText>
                        </div>
                    ) : (
                        <IonList lines="none">
                            {(Array.isArray(notifications) ? notifications : []).map((n) => (
                                <IonItem
                                    key={n.id}
                                    className={`notification-item ${n.is_seen ? "seen" : "unseen"}`}
                                >
                                    <IonLabel onClick={() => redirectToModule(n)}>
                                        <h2>{n.message}</h2>
                                        <p>{new Date(n.created_at).toLocaleString()}</p>
                                    </IonLabel>
                                    {!n.is_seen && (
                                        <IonButton
                                            slot="end"
                                            fill="outline"
                                            size="small"
                                            onClick={() => onMarkSeen(n.id)}
                                        >
                                            Mark Seen
                                        </IonButton>
                                    )}
                                </IonItem>
                            ))}
                        </IonList>
                    )}
            </IonContent>
        </IonModal>
    );
};

export default NotificationSheet;
